import Logo from "../assets/img/logo.png";
import Bin from "../assets/img/bin.png";
import Calculate from "../assets/img/calculate.png";
import Close from "../assets/img/close.svg";
import Email from "../assets/img/email.svg";
import Calendar from "../assets/img/calendar.svg";
import WhiteEmail from "../assets/img/white_email.svg";
import Line from "../assets/img/line.png";
import FullScreen from "../assets/img/fullscreen.svg";
import PartScreen from "../assets/img/partscreen.svg";
import Home from "../assets/img/draw.svg";
import Clear from "../assets/img/clear.svg";
import Plus from "../assets/img/plus.svg";
import Minus from "../assets/img/minus.svg";
import Panorame from "../assets/img/panorame.svg";
import HZSLogo from "../assets/img/hzs-logob.png";
import StapFaq2 from "../assets/img/faq_2.png";
import StepFaq3 from "../assets/img/faq_3.png";
import StepFaq3Mobile from "../assets/img/faq_3_mobile.png";
import StepScreen from "../assets/img/faq_screen.png";


export const IMAGES = {
  LOGO: Logo,
  BIN: Bin,
  CALCULATE: Calculate,
  CLOSE: Close,
  EMAIL: Email,
  CALENDAR: Calendar,
  WHITE_EMAIL: WhiteEmail,
  LINE: Line,
  FULLSCREEN: FullScreen,
  PARTSCREEN: PartScreen,
  HOME: Home,
  CLEAR: Clear,
  PLUS: Plus,
  MINUS: Minus,
  PANORAME: Panorame,
  HZS_LOGO: HZSLogo,
  STEP_FAQ_2: StapFaq2,
  STEP_FAQ_3: StepFaq3,
  STEP_FAQ_3_MOBILE: StepFaq3Mobile,
  STEP_SCREEN: StepScreen,
};
